import { render, staticRenderFns } from "./EditExpenseItem.vue?vue&type=template&id=55caf22a"
import script from "./EditExpenseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EditExpenseItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports